import { Backdrop, Button, Checkbox, Chip, FormControlLabel, Grid, IconButton, Switch, Typography } from "@mui/material";
import { useFormik } from 'formik';
import React, { Fragment, useEffect, useState } from "react";
import * as yup from 'yup';
import CustomDataGrid from "../../../../../components/dataTable/customDataGrid";
import CustomTextField from "../../../../../components/utils/input/customTextField";
import Modal from "../../../../../components/utils/modal/modal";
import { useDispatch } from "react-redux";
import DeletePage from "../../../../../components/utils/deleteModal/deletePage";
import axios from "axios";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { Delete, EditNote } from "@mui/icons-material";
import _ from "lodash";
import Loader from "../../../../../components/loader/loader";
import { Helmet } from "react-helmet-async";

const TypeDesign = () => {
  const dispatch = useDispatch()
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([])
  const [isEdit, setIsEdit] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [active, setActive] = useState(false)
  const [activeId, setActiveId] = useState(null)
  const [isLoader, setIsLoader] = useState(false); //loader
  
const validationSchema = yup.object({
  typeDesign : yup.string().required(),
})

const formik = useFormik({
  initialValues :{
    typeDesign : ""
  },
  validationSchema:validationSchema,
onSubmit: isEdit ? handleUpdate : handleCreate
})

const columns = [
  {
    field: "sno",
    headerName: "S.no",
    flex: 1,
    minWidth: 70,
    maxWidth: 100,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "name",
    headerName: "Type Design",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "isActive",
    headerName: "Status",
    flex: 1,
    disableExport: true ,
    headerAlign: "center",
    align: "center",
    sortable: false,
    disableColumnMenu: true,
    renderCell: (params) => (
      <div className="">
        <Chip size='small' color={params.row.isActive ? 'success' : 'error'} label={params.row.isActive ? 'Active' : 'Inactive'}/>
    </div>
    )
  },
  {
    field: 'action',
    headerName: 'Action',
    flex: 1,
    disableExport: true ,
    minWidth: 100,
    headerAlign: "center",
    align: "center",
    editable: false,
    sortable: false,
    disableColumnMenu: true,
    renderCell: (params) => (
      <div className='flex justify-center w-full'>
        <IconButton onClick={()=>onEdit(params.row)} >
          <EditNote sx={{color:"#1972d2",fontSize:22}}/>
        </IconButton>
        <IconButton onClick={() => OnDelete(params.id)}>
          <Delete sx={{color:"red",fontSize:22}}/>
        </IconButton>
      </div>
    ),
  },
];

const rows = _.map(data,(val,idx)=>({
  id:val.id,
  sno: ++idx,
  name: val.type_name,
  isActive: val.is_active
}))
const props = {
  rows: rows,
  columns: columns,
  search: search,
  setSearch: setSearch,
  page: page,
  setPage: setPage,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
};

const onCreate = () =>{
  setOpen(true)
  formik.resetForm()
  setIsEdit(false)
}
function handleCreate(){
  const typeData = {
    type_name: formik.values.typeDesign,
    is_active: active,
    company_id:2
  }
  setIsLoader(true);
  axios.post(`/v1/typedesign`, typeData)
  .then(res=>{
    dispatch(setSnackbar(true,'success', 'Created Successfuly'))
    setOpen(false)
    gettypeDesignData()
    setIsLoader(false);
  })
  .catch(err=>{
    dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
    setIsLoader(false);
  })
}

  function onEdit(e){
    console.log(e)
    formik.setFieldValue('typeDesign', e.name)
    setActive(e.isActive)
    setIsEdit(true)
    setOpen(true)
    setActiveId(e.id)
  }

  function handleUpdate(){
    const typeData = {
      type_name: formik.values.typeDesign,
      is_active: active,
      company_id:2
    }
    setIsLoader(true);
    axios.put(`/v1/typedesign/${activeId}`, typeData)
    .then(res=>{
      dispatch(setSnackbar(true,'success', 'Updated Successfuly'))
      setOpen(false)
      gettypeDesignData()
      setIsLoader(false);
    })
    .catch(err=>{
      dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
      setIsLoader(false);
    })
  }
  function OnDelete(id){
    setOpenDialog(true)
    setActiveId(id)
  }    

  const handleDelete = ()=>{
    setIsLoader(true);
    axios.delete(`/v1/typedesign/${activeId}`)
    .then(res=>{
      dispatch(setSnackbar(true, 'success', 'Deleted Successfully'))
      setOpenDialog(false)
      gettypeDesignData()
      setIsLoader(false);
      setOpen(false)
    })
    .catch(err=>{
      dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
      setIsLoader(false);
    })
    }
    
    const gettypeDesignData = () =>{
      setIsLoader(true);
      const url = `/v1/typedesign/${rowsPerPage}/${page + 1}`
      const searchUrl = `/v1/typedesign/${rowsPerPage}/${page + 1}/${search}`
      axios.get(search === '' ? url : searchUrl)
      .then(res=>{
        setData(res.data.data)
        setPageCount(res.data.meta.pagination.total)
        setIsLoader(false);
      })
      .catch(err=>{
        console.log(err)
        setIsLoader(false);
        dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
      })
    }
    
    useEffect(()=>{
      gettypeDesignData()
    },[rowsPerPage, search,  page]) 

  return (
    <Fragment>
      <Helmet>
        <title>
        Type design
      </title>
        </Helmet>
      <Typography variant="h5">Type Design</Typography>
      {!open &&
  <Grid className='flex justify-end'>
    <Button variant='contained' size='small' onClick={onCreate}>Create New</Button>
</Grid>}
{open &&
<Modal onClose={setOpen} onSave={formik.handleSubmit} formik={formik} isEdit={isEdit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={3} >
            <CustomTextField id='typeDesign' value={formik.values.typeDesign} title='Type Design' multiple={false} placeholder='Enter type design' onchange={formik.handleChange} errorMsg={formik.touched.typeDesign && Boolean(formik.errors.typeDesign)} helperText={formik.touched.typeDesign && formik.errors.typeDesign}/>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} className="flex items-center">
            <FormControlLabel  control={<Checkbox checked={active} onChange={()=>setActive(!active)}/>} label="Active" />
            </Grid>
            
          </Grid>
        </Modal>
      }
      <Grid className="bg-white rounded-md p-2 my-3">
        <CustomDataGrid props={props} />
      </Grid>
      <Backdrop open={openDialog} sx={{zIndex:1350}}>
  <DeletePage onCancel={setOpenDialog} onSubmit={handleDelete}/>
</Backdrop>
{/* <Loader isLoader={isLoader}/> */}
    </Fragment>
  );
};

export default TypeDesign;
